import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { Field } from 'redux-form';
import { propArrayShape, propBool, propFunc, propShape, propStr, propValidate, } from '../../helpers/custom-prop-types';
import PlainInput from './Common/PlainInput';
//
// Basic fields
//
export const StandardField = ({ className, disabled, errorClassName, input, meta, noWrap, placeholder, type, }) => {
    const WrapComponent = noWrap ? Fragment : 'div';
    return (_jsxs(WrapComponent, { children: [_jsx("input", Object.assign({}, input, { className: `input-form-text ${className || ''} ${meta.touched && meta.error ? 'is-warning' : ''}`, disabled: disabled, placeholder: placeholder, type: type })), meta.touched && meta.error && (_jsx("div", { children: _jsx("span", Object.assign({ className: `font-alert ${errorClassName || ''}` }, { children: meta.error })) }))] }));
};
StandardField.propTypes = {
    className: propStr(),
    disabled: propBool(),
    errorClassName: propStr(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
    noWrap: propBool(),
    placeholder: propStr(),
    type: propStr().isRequired,
};
StandardField.defaultProps = {
    className: '',
    disabled: false,
    errorClassName: '',
    noWrap: false,
    placeholder: '',
};
export const StandardTextArea = (props) => {
    const { disabled, input, meta, name, placeholder } = props;
    return (_jsxs("div", { children: [_jsx("textarea", Object.assign({}, input, { className: `input-form-textarea ${meta.touched && meta.error ? 'is-warning' : null}`, disabled: disabled, name: name, placeholder: placeholder })), meta.touched && meta.error && (_jsx("div", { children: _jsx("span", Object.assign({ className: 'font-alert' }, { children: meta.error })) }))] }));
};
StandardTextArea.propTypes = {
    disabled: propBool(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
    name: propStr().isRequired,
    placeholder: propStr(),
};
StandardTextArea.defaultProps = {
    disabled: false,
    placeholder: '',
};
export const Checkbox = (props) => {
    const { className, disabled, labelName, name, option, valueName, wrapOnChange, } = props;
    const id = `${name}#${option[valueName]}`;
    return (_jsxs(_Fragment, { children: [_jsx(Field, { className: 'mdc-checkbox__native-control', component: PlainInput, disabled: disabled, id: id, name: name, type: 'checkbox', wrapOnChange: wrapOnChange }), ' ', _jsx("label", Object.assign({ className: className, htmlFor: id }, { children: option[labelName] }))] }));
};
Checkbox.propTypes = {
    className: propStr(),
    disabled: propBool(),
    labelName: propStr(),
    name: propStr().isRequired,
    option: propShape().isRequired,
    valueName: propStr(),
    wrapOnChange: propFunc(),
};
Checkbox.defaultProps = {
    className: 'mdc-checkbox__native-control',
    disabled: false,
    labelName: 'label',
    valueName: 'value',
    wrapOnChange: undefined,
};
export const Checkboxes = ({ name, options, validate }) => (_jsx("ul", Object.assign({ className: 'form-solution-select' }, { children: options.map((option, index) => {
        const id = `${name}#${option.value}`;
        return (_jsxs("li", { children: [_jsx(Field, { className: 'mdc-checkbox__native-control', component: 'input', id: id, name: `${name}[${index}]`, type: 'checkbox', validate: validate }), ' ', _jsx("label", Object.assign({ htmlFor: id }, { children: option.label }))] }, id));
    }) })));
Checkboxes.propTypes = {
    name: propStr().isRequired,
    options: propArrayShape().isRequired,
    validate: propValidate(),
};
Checkboxes.defaultProps = {
    validate: [],
};
export const Selectboxes = ({ disabled, name, onChange, options }) => (_jsx(Field, Object.assign({ component: 'select', name: name, onChange: onChange, props: {
        disabled,
    } }, { children: options.map((option) => {
        const id = `${name}#${option.value}`;
        return (_jsx("option", Object.assign({ value: option.value.toString() }, { children: option.label }), id));
    }) })));
Selectboxes.propTypes = {
    disabled: propBool(),
    name: propStr().isRequired,
    onChange: propFunc(),
    options: propArrayShape().isRequired,
};
Selectboxes.defaultProps = {
    disabled: false,
    onChange: () => null,
};
export const RadioButtons = ({ name, options, validate }) => (_jsx("ul", Object.assign({ className: 'form-solution-select' }, { children: options.map((option) => {
        const id = `${name}#${option.value}`;
        return (_jsxs("li", { children: [_jsx(Field, { className: 'mdc-radio__native-control', component: 'input', id: id, name: name, type: 'radio', validate: validate, value: option.value.toString() }), ' ', _jsx("label", Object.assign({ htmlFor: id }, { children: option.label }))] }, id));
    }) })));
RadioButtons.propTypes = {
    name: propStr().isRequired,
    options: propArrayShape().isRequired,
    validate: propValidate(),
};
RadioButtons.defaultProps = {
    validate: [],
};
